module.exports = __webpack_public_path__ + "img/mangbagja_sedih.4b1be7db.jpg";